module.exports = __webpack_public_path__ + "img/f4e6edd.png";